import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { GungLanguageConfigService } from 'gung-common';
import { GungListRouterEventsService } from 'gung-list';
import {
  AppWrapperComponent,
  AppState,
  AuthService,
  ProductService,
  MetadataService,
  GoogleAnalyticsService,
  NavbarConfigService,
  SelectedCustomerService,
  RouterEventsService,
  NavigationConfig,
  BaseViewConfigService,
  GungVersionValidatorService,
  GungModalService
} from 'gung-standard';
import { first, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'tylo-app-wrapper',
  templateUrl: './tylo-app-wrapper.component.html',
  styleUrls: ['./tylo-app-wrapper.component.css']
})
export class TyloAppWrapperComponent extends AppWrapperComponent implements OnInit, OnDestroy {
  constructor(
    protected store: Store<AppState>,
    protected authService: AuthService,
    protected productService: ProductService,
    protected metadataService: MetadataService,
    protected googleAnalyticsService: GoogleAnalyticsService,
    protected navbarConfigService: NavbarConfigService,
    protected router: Router,
    protected routerEventsService: RouterEventsService,
    protected selectedCustomerService: SelectedCustomerService,
    protected gungListRouterEventsService: GungListRouterEventsService,
    route: ActivatedRoute,
    translate: TranslateService,
    @Optional()
    @Inject('environment')
    protected environment: NavigationConfig,
    protected baseViewConfigService: BaseViewConfigService,
    protected gungLanguageConfigService: GungLanguageConfigService,
    protected gungVersionValidatorService: GungVersionValidatorService,
    protected modalService: GungModalService
  ) {
    super(
      store,
      authService,
      productService,
      metadataService,
      googleAnalyticsService,
      navbarConfigService,
      router,
      routerEventsService,
      gungListRouterEventsService,
      route,
      translate,
      selectedCustomerService,
      gungLanguageConfigService,
      environment,
      baseViewConfigService,
      gungVersionValidatorService,
      modalService
    );
  }

  ngOnInit() {
    super.ngOnInit();
    this.loadChatScript();
    this.selectedCustomerService
      .getSelectedCustomer()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(_ =>
        this.navbarConfigService
          .getMainMenu()
          .pipe(first())
          .subscribe(menu => (this.mainMenu = menu))
      );
  }

  private loadChatScript() {
    const body = document.body;
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = ``;
    script.id = 'hs-script-loader';
    script.src = '//js.hs-scripts.com/379485.js';
    script.async = true;
    script.defer = true;
    body.appendChild(script);
  }
}
